// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"841d36ae","239":"d7b64061","431":"195bf6c4","433":"60871d7a","453":"a3bfcd73","455":"4870ad57","977":"0c8eb359"}[chunkId] + ".chunk.js";
};